/**
 * M2-B rev 4: человекочитаемая причина статуса.
 * Известные коды — перевод из search.reason.*; неизвестные и динамические
 * коды НЕ показываются сырыми — локализованный fallback.
 */
export function reasonLabel(
  t: (key: string, opts?: Record<string, unknown>) => string,
  code: string,
): string {
  const label = t(`search.reason.${code}`, { defaultValue: '' });
  return label !== '' ? label : t('search.reason.unknown');
}

/** M2-B rev 4: человекочитаемый статус; неизвестный код не показывается
 *  сырым — локализованный fallback; пустое значение — тире. */
export function statusLabel(
  t: (key: string, opts?: Record<string, unknown>) => string,
  code: string | null | undefined,
): string {
  if (!code) return "-";
  const label = t(`search.status.${code}`, { defaultValue: "" });
  return label !== "" ? label : t("search.status.unknown");
}
